// @component ./BlockInfo.tsx
export { default as Info } from './BlockInfo'
